let validateCheckbox = (function ($) {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            button: '#checkbox-validate-button',
            openModalButton: '#open-modal-button',
            checkboxSection: '.vds-checkbox',
            checkbox: '.vds-checkbox__input',
            validationMessageSection: '#checkbox-validation-message',
            partnerSignupEligibility: '#partner-signup-eligibility',
            signupAttribute: 'data-partner-signup-enabled'
        },
        css: {
            invalid: 'vds-checkbox--invalid',
            hide: 'vds-item-hidden',
            disableButton: 'vds-button--disabled'
        },
        func: {
            init: function () {
                if ($(self.elements.partnerSignupEligibility).attr(self.elements.signupAttribute)?.toLowerCase() === 'false') {
                    self.func.disableSignUp();
                } else {
                    self.func.bindings();
                }
            },
            disableSignUp: function () {
                $(self.elements.button).addClass(self.css.disableButton);
                $(self.elements.openModalButton).addClass(self.css.disableButton);
                $(self.elements.checkbox).attr('disabled', true);
            },
            bindings: function () {
                $(self.elements.button).on('click', self.func.validateCheckbox);
                $(self.elements.openModalButton).on('click', self.func.openModal);
                $(self.elements.checkbox).on('change', self.func.onCheckboxUpdate);
            },
            isValidCheckboxSelection: function () {
                if ($(self.elements.checkbox).prop('checked')) {
                    return true;
                } else {
                    $(self.elements.checkboxSection).addClass(self.css.invalid);
                    $(self.elements.validationMessageSection).removeClass(self.css.hide);

                    return false;
                }
            },
            validateCheckbox: function (event) {
                event.preventDefault();
                if (self.func.isValidCheckboxSelection()) {
                    sessionStorage.setItem(self.elements.checkbox, $(self.elements.checkbox).prop('checked'));
                    window.location.href = event.target.href;
                } else {
                    $(self.elements.checkboxSection).addClass(self.css.invalid);
                    $(self.elements.validationMessageSection).removeClass(self.css.hide);
                }
            },
            openModal: function (event) {
                event.preventDefault();
                if (self.func.isValidCheckboxSelection()) {
                    const gtmEvent = $(self.elements.openModalButton).data('gtmevent');
                    const gtmCategory = $(self.elements.openModalButton).data('gtmcategory');
                    if (gtmEvent.length > 0) {
                        window.dataLayer.push({event: gtmEvent, cta_text: gtmCategory});
                    }
                    window.Utilities.func.openModal($(self.elements.openModalButton).data('modalpopup'));
                }
            },
            onCheckboxUpdate: function () {
                $(self.elements.checkboxSection).removeClass(self.css.invalid);
                $(self.elements.validationMessageSection).addClass(self.css.hide);
            }
        }
    };
    return {
        init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    if ($('#checkboxwithvalidation').length > 0) {
        validateCheckbox.init();
    }
});
